module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_pointer-bc6d33153d0eb69fc681632e37225c3c.png";